export default __webpack_public_path__ + "static/media/author.08ce57e7.svg";